'use strict';

// Import module
import './module/ham';
import './module/zoom';
import './module/modal';
import './module/acc';
import './module/float';
// Sass Import
import '../Sass/style.scss';
